// components/Dialog.jsx
export default function Dialog({ open, onClose, label, children }) {
  if (!open) return null;

  return (
    <div
      // onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 12,
          width: "100%",
          maxWidth: 600,
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          margin: 16,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", columnGap: "5px", padding: "16px 20px", justifyContent:"space-between", fontWeight: 600, fontSize: 18, borderBottom: "1px solid #eee" }}>
            <span style={{ fontWeight: 600, fontSize: 18 }}>{label}</span>
            <div onClick={onClose} style={{ cursor: "pointer" }}>X</div>
        </div>

        <div style={{ padding: 20, overflowY: "auto", flex: 1 }}>
          {children}
        </div>

      </div>
    </div>
  );
}